import React, { useEffect, useState } from 'react';
import { word } from '../../word.js'
import { useSelector } from "react-redux";
import Api from '../../Api.js'
import MessageList from '../TaskSingleComponents/MessageList.js';
import Message from '../TaskSingleComponents/Message.js';
const MessageInput = ({ visibleMessage, form }) => {
    const [message, setMessage] = useState([]);
    const login = useSelector((state) => state.manager.employee);

    const [text, setText] = useState('');
    const [sendMessage, setSendMessage] = useState(false);
    const [file, setFile] = useState('');
    const [filePreviewUrl, setFilePreviewUrl] = useState('');
    const handleTaskSms = async () => {
        try {
            if (text === '' && !file) return;
            const formData = new FormData();
            formData.append("text", text);
            formData.append("file", file);
            formData.append("task", form?.id);

            setSendMessage(true);
            await Api.sendMessageAgent(formData)
            const { data } = await Api.getMessageAgent(form?.id, {
                start_index: 0,
                for_all: null,
            })
            setMessage(data);
            setSendMessage(false);
            setText('');
            setFile('');
        } catch (e) {
            setSendMessage(false);

        }

    };

    const keyPress = async (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!sendMessage) {
                await handleTaskSms();
            }
        }
    };


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        if (selectedFile.size === 0) {
            alert("Ֆայլը դատարկ է");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setFile(selectedFile);
            setFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(selectedFile);
    };
    useEffect(() => {
        (async () => {
            const { data } = await Api.getMessageAgent(form.id)
            setMessage(data)
        })()
    }, [form.id])
    return (
        <div className="message-list-inputs">
            {visibleMessage && <div className="message-list" >
                {message.map((item, index) => {
                    const profession = localStorage.getItem('profession');
                    const isMine = item.agent?.id === login.id
                    return <Message key={index} data={item} isMine={isMine} />;
                })}</div>}
            {visibleMessage && (
                <div className="send-message">
                    <div className='input-image w-100'>
                        <div>{filePreviewUrl && <img src={filePreviewUrl} alt="Preview" />}</div>
                        <div className="send-file">
                            <textarea
                                style={{ width: 300 }}
                                className='area'
                                readOnly={sendMessage}
                                onKeyDown={keyPress}
                                name="text"
                                autoFocus
                                placeholder={word.enter_message}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                            />
                            <div className='message-icons'>

                                <label>
                                    <i className="fas fa-image" />
                                    <input
                                        type="file"
                                        className='input-icon'
                                        onChange={handleFileChange}
                                    />
                                </label>
                                <i
                                    onClick={async () => {
                                        if (!sendMessage) await handleTaskSms();
                                    }}
                                    className="fa fa-paper-plane"
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MessageInput;
